import Header from "./../compoents/common/Header";
import Footer from "./../compoents/common/Footer";
import { useEffect, useState } from "react";
import { pageDataApi,homePageApi, baseUrl} from "../utils/apis";
import ReactMarkdown from 'react-markdown'

const AboutPage = (props) => {
  const [homePageState, setHomePageState] = useState({});
  const [pageData, setPageData] = useState({});

  useEffect(() => {
    homePageApi().then((data)=>{
      if(data){
        setHomePageState(data)
      }
    });
    pageDataApi('about').then((data)=>{
      if(data && data.length > 0){
        setPageData(data[0])
      }
    });
    
  }, [])
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props])

  return (
    <>
      <Header emailText={homePageState.contactUs}
          phoneText={homePageState.PhoneNumber} />
          
          <div class="full_width ds_page_banner bg-center" style={{background:pageData && pageData.banner?'url('+ baseUrl + pageData.banner.url  +')':'black'}}  >
	<div class="black_overlay">
		<div class="container">
			<div class="row">
				<div class="page_content_wrap">
					<div class="page_heading">
						<h1>{"Refund Policy"}</h1>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
      <div id="courses" className="full_width contact_section" >
        <div className="container">
          <div className="row">
            {/* heading section */}
            <div className="content" >
            <div>
        <b>Returns</b>
        <p>Our policy lasts 30 days. If 30 days have gone by since your purchase, unfortunately we can’t offer you a refund or exchange.</p>
        <p><br /></p>
        <p>To be eligible for a return, your item must be unused and in the same condition that you received it. It must also be in the original packaging.</p>
        <p><br /></p>
        <p>Several types of goods are exempt from being returned. Perishable goods such as food, flowers, newspapers or magazines cannot be returned. We also do not accept products that are intimate or sanitary goods, hazardous materials, or flammable liquids or gases.</p>
        <p><br /></p>
        <p>Additional non-returnable items:</p>
        <ul>
          <li>
            <p>Gift cards</p>
          </li>
          <li>
            <p>Downloadable software products</p>
          </li>
          <li>
            <p>Some health and personal care items</p>
          </li>
        </ul>
        <p><br /></p>
        <p>To complete your return, we require a receipt or proof of purchase.</p>
        <p><br /></p>
        <p>Please do not send your purchase back to the manufacturer.</p>
        <p><br /></p>
        <p>There are certain situations where only partial refunds are granted: (if applicable)</p>
        <p>Book with obvious signs of use</p>
        <p>CD, DVD, VHS tape, software, video game, cassette tape, or vinyl record that has been opened.</p>
        <p>Any item not in its original condition, is damaged or missing parts for reasons not due to our error.</p>
        <p>Any item that is returned more than 30 days after delivery</p>
        <p><br /></p>
        <p>Refunds (if applicable)</p>
        <p>Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your refund.</p>
        <p>If you are approved, then your refund will be processed, and a credit will automatically be applied to your credit card or original method of payment, within a certain amount of days.&nbsp;</p>
        <p><br /></p>
        <p>Late or missing refunds (if applicable)</p>
        <p>If you haven’t received a refund yet, first check your bank account again.</p>
        <p>Then contact your credit card company, it may take some time before your refund is officially posted.</p>
        <p>Next contact your bank. There is often some processing time before a refund is posted.</p>
        <p>If you’ve done all of this and you still have not received your refund yet, please contact us at Saidrivingacademy@gmail.com&nbsp;</p>
        <p><br /></p>
        <p>Sale items (if applicable)</p>
        <p>Only regular priced items may be refunded, unfortunately sale items cannot be refunded.</p>
        <p><br /></p>
        <p>Exchanges (if applicable)</p>
        <p>We only replace items if they are defective or damaged. &nbsp;If you need to exchange it for the same item, send us an email at Saidrivingacademy@gmail.com &nbsp;and send your item to: 622 Manglam Electronic Market Jaipur Rajasthan India 302001.</p>
        <p><br /></p>
        <p>Gifts</p>
        <p>If the item was marked as a gift when purchased and shipped directly to you, you’ll receive a gift credit for the value of your return. Once the returned item is received, a gift certificate will be mailed to you.</p>
        <p><br /></p>
        <p>If the item wasn’t marked as a gift when purchased, or the gift giver had the order shipped to themselves to give to you later, we will send a refund to the gift giver and he will find out about your return.</p>
        <p><br /></p>
        <p>Shipping</p>
        <p>To return your product, you should mail your product to: 622 Manglam Electronic Market Jaipur Rajasthan India 302001.</p>
        <p><br /></p>
        <p>You will be responsible for paying for your own shipping costs for returning your item. Shipping costs are non-refundable. If you receive a refund, the cost of return shipping will be deducted from your refund.</p>
        <p><br /></p>
        <p>Depending on where you live, the time it may take for your exchanged product to reach you, may vary.</p>
        <p><br /></p>
        <p>If you are shipping an item over $75, you should consider using a trackable shipping service or purchasing shipping insurance. We don’t guarantee that we will receive your returned item.</p>
        <p><br /></p>
      </div>
            </div>
          </div>
        </div>
      </div>
       <Footer 
          aboutText={homePageState.About}
          addressText={homePageState.Address}
          emailText={homePageState.contactUs}
          phoneText={homePageState.PhoneNumber}
        />
    </>
  );
};

export default AboutPage;
